import Swiper from 'swiper'
import {Navigation} from "swiper/modules";

export default function () {
    document.addEventListener('DOMContentLoaded', () => {

        function init(element: HTMLElement) {
            const sliderEl = element

            if (!sliderEl) return
            new Swiper(sliderEl, {
                spaceBetween: '16px',
                slidesPerView: 1.2,
                speed: 500,
                loop: true,
                modules: [Navigation],
                navigation: {
                    prevEl: '.references-slider-wrapper .slider-control-left',
                    nextEl: '.references-slider-wrapper .slider-control-right'
                },
                autoHeight: true,
                breakpoints: {
                    440: {
                        slidesPerView: 1.5
                    },
                    640: {
                        slidesPerView: 2,
                        spaceBetween: '24px'
                    },
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: true
                    },
                    1400: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: true
                    },
                },
            })
        }

        const referencesSliders = document.querySelectorAll<HTMLElement>('[data-references-slider]')

        if (referencesSliders.length > 0) {
            referencesSliders.forEach((element) => {
                if (element instanceof HTMLElement) {
                    init(element)
                }
            })
        }

    })
}
